import "./portfolio-card.css";

const PortfolioCard = ({
  name,
  description,
  technologies,
  repoLink,
  webLink,
  cardRef,
}) => {
  return (
    <div className="portfolio-card" ref={cardRef}>
      <div className="d-flex justify-content-center">
        <img
          width="50"
          height="50"
          src="./assets/icons/tech.svg"
          alt="portfolio-card-img"
        />
        <div className="portfolio-card-content d-flex flex-column justify-content-between align-items-center">
          <h2 className="portfolio-card-header">{name}</h2>
          <p className="portfolio-card-desc">{description}</p>
          <p className="portfolio-card-technologies">
            {technologies.map((technology, index) =>
              index === technologies.length - 1 ? technology : technology + ", "
            )}
          </p>
          <div className="portfolio-links d-flex">
            <a
              href={repoLink}
              target="_blank"
              rel="noreferrer"
              title="Github Repo"
            >
              <i className="fa-brands fa-github"></i>
            </a>
            <a
              className={webLink === undefined && "d-none"}
              href={webLink}
              target="_blank"
              rel="noreferrer"
              title="Website Link"
            >
              <i className="fa-solid fa-window-restore"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;
